import React from 'react';
import styled from 'styled-components';
import Flex from '../Flex';
import theme from '../theme';
import Typo from '../Typo';
// Import the SVG as a regular image instead of a React component
import coursioLogotype from '../assets/coursio-logotype.svg';
import coursioImg from '../assets/coursio-creen.png';

const CoursioLogo = styled.img`
  margin-bottom: ${(props) => props.marginbottom};
  max-width: 285px;
  height: auto;
`;

const CoursioImage = styled.img`
  max-width: 100px;
  margin-bottom: ${(props) => props.marginBottom};
`;

const HeaderFlex = styled(Flex)`
  padding-top: ${({ $lightBackground }) => ($lightBackground ? '0' : '1rem')};
  padding-bottom: ${({ $lightBackground }) => ($lightBackground ? '0' : '1rem')};
`;

const PageHeaderLogo = ({ message, marginBottom, lightBackground }) => {
  return (
    <HeaderFlex gap='30' direction='column' $lightBackground={lightBackground}>
      {!lightBackground ? (
        <CoursioLogo src={coursioLogotype} marginbottom={marginBottom} alt='Coursio Logo' />
      ) : (
        <CoursioImage src={coursioImg} marginBottom={marginBottom} alt='Coursio Logo' />
      )}
      {message && <Typo.ContentSmallHeader $themeColor={!lightBackground && theme.colors.PRIMARY}>{message}</Typo.ContentSmallHeader>}
    </HeaderFlex>
  );
};

export default PageHeaderLogo;
